import React from 'react';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import Image from '@gcloud-npm/next12.components.image-n';
import Button from '@gcloud-npm/next12.components.button-m';
import styled from 'styled-components';

const StyledLabel = styled.span`
  padding: 0.25rem 0.75em;
  background-color: white;
  border-radius: 1rem;
  border: solid 0.0625rem var(--color-emp--grey4);
  align-items: center;
  margin-left: 1.25rem;
`;

const StyledButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.8125rem;
  margin-bottom: 2rem;
  margin-left: auto;
  margin-right: auto;
  .buttons--wrapper {
    width: 100%;
    margin: 0rem 0.5rem;
  }
  @media screen and (min-width: 769px) {
    margin-top: 2.8125rem;
    width: 24.0625rem;
  }
  @media screen and (max-width: 768px) {
    span {
      font-size: 0.875rem !important;
    }
  }
`;

const COMPONENT_NAME = 'icon-listing';

const Necessities = (props) => {
  const { components } = props;
  const title = props['TextInfo-1'];
  const subtitle = props['TextInfo-2'];
  const button1 = props['Button-1'];
  const button2 = props['Button-2'];

  const taggingInfo = {
    componentVariation: 'all',
    componentName: COMPONENT_NAME,
    componentProduct: '',
  };

  const printLabel = (text) => {
    return (
      <StyledLabel>
        <TextInfo
          text={text}
          kind="span"
          display="inline"
          fontType="font-regular"
          size="caption03"
          color="blue"
          className="label"
        />
      </StyledLabel>
    );
  };

  return (
    <>
      <section className="Necessities container">
        {title && (
          <div className="title">
            <TextInfo {...title} />
          </div>
        )}
        {subtitle && subtitle.text && (
          <div className="subtitle">
            <TextInfo {...subtitle} />
          </div>
        )}
        <div className="components">
          {components.map((component) => (
            <div className="card">
              <div className="iconBg">
                <div className="icon">
                  <Image
                    src={`${process.env.NEXT_PUBLIC_CDN}/${component['Image-1'].src}`}
                    alt={component['Image-1'].alt}
                    layout="fixed"
                    width={component['Image-1'].width}
                    height={component['Image-1'].height}
                  />
                </div>
              </div>
              <div className="textWrapper">
                <div className="title">
                  <TextInfo {...component['TextInfo-1']} />
                  {component.exclusivo && printLabel('Exclusivo')}
                </div>
                <div className="text">
                  <TextInfo {...component['TextInfo-2']} />
                </div>
              </div>
            </div>
          ))}
        </div>
        {(button1 || button2) && (
          <StyledButtons>
            {button1 && (
              <div className="buttons--wrapper">
                <Button
                  {...button1}
                  taggingInfo={{
                    ...taggingInfo,
                    componentContent: button1.label,
                  }}
                />
              </div>
            )}
            {button2 && (
              <div className="buttons--wrapper">
                <Button
                  {...button2}
                  taggingInfo={{
                    ...taggingInfo,
                    componentContent: button2.label,
                  }}
                />
              </div>
            )}
          </StyledButtons>
        )}
      </section>
      <style jsx>
        {`
          .Necessities {
            padding-top: 3rem;
            .title {
              margin-bottom: 1rem;
            }
            .button--wrapper {
              display: initial;
              justify-content: center;
            }
            .components {
              display: flex;
              flex-direction: column;
              padding: 1rem 0;
              .card {
                display: flex;
                flex-direction: row;
                padding: 1rem 0;
                .iconBg {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: var(--color-emp--grey1);
                  border-radius: 50%;
                  min-width: 5rem;
                  max-width: 5rem;
                  min-height: 5rem;
                  max-height: 5rem;
                  margin-right: 2rem;
                  .icon {
                    color: var(--color-emp--blue);
                  }
                }
              }
            }
          }
          @media screen and (min-width: 769px) {
            .Necessities {
              .button--wrapper {
                display: flex;
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default Necessities;
